interface PotIconProps {
  size?: number
  className?: string
  showBadge?: boolean
  badgeCount?: number
}

export default function PotIcon({ size = 24, className = "", showBadge = false, badgeCount = 0 }: PotIconProps) {
  return (
    <div className={`relative ${className}`}>
      {/* Tencere SVG Icon */}
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="transition-all duration-200 hover:scale-110"
      >
        {/* Tencere Gövdesi */}
        <path d="M4 8h16v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8z" />
        
        {/* Tencere Kenarları */}
        <path d="M3 8h18" />
        
        {/* Sol Kulp */}
        <path d="M4 8V6a1 1 0 0 1 1-1h2" />
        
        {/* Sağ Kulp */}
        <path d="M20 8V6a1 1 0 0 0-1-1h-2" />
        
        {/* Kapak */}
        <ellipse cx="12" cy="8" rx="8" ry="1" />
        
        {/* Buhar Çizgileri */}
        <path d="M9 4v1" strokeWidth="1.5" />
        <path d="M12 3v2" strokeWidth="1.5" />
        <path d="M15 4v1" strokeWidth="1.5" />
        
        {/* İçerik İpucu */}
        <circle cx="10" cy="12" r="1" opacity="0.6" />
        <circle cx="14" cy="14" r="1" opacity="0.6" />
      </svg>

      {/* Badge (Sepet Sayısı) */}
      {showBadge && badgeCount > 0 && (
        <div className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full min-w-[20px] h-5 flex items-center justify-center px-1 shadow-lg animate-pulse">
          {badgeCount > 99 ? '99+' : badgeCount}
        </div>
      )}

      {/* Hover Effect */}
      <div className="absolute inset-0 bg-purple-500 rounded-full opacity-0 scale-75 transition-all duration-200 group-hover:opacity-20 group-hover:scale-100 pointer-events-none" />
    </div>
  )
}